"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tsm_1 = require("@tlaukkan/tsm");
var Store_1 = __importDefault(require("../Store"));
function getCameraForPos(pos, currentPos) {
    var envInfo = Store_1.default.getState().EnvironmentInfo;
    if (envInfo) {
        var car = envInfo.mastermodel;
        var id = [car.manufacturer, car.model, car.year].join(" ");
        var cardata = envInfo.vehicle;
        //console.log("getcameraforpos", car, cardata);
        if (cardata !== undefined && Object.keys(cardata).length > 0) {
            var carmeta = cardata[id] || Object.values(cardata[0]);
            //console.log("carmeta", carmeta);
            if (carmeta.metadata && carmeta.metadata.cameras) {
                var cam = Object.values(carmeta.metadata.cameras).find(function (c) { return c.id === window.zlbolt.getCamera(); });
                if (cam && cam["2DOD"] && !cam.interior) {
                    var samples = cam["2DOD"].samples;
                    if (samples) {
                        //console.log("samples", samples);
                        var dist = -1;
                        var index = -1;
                        for (var s = 0; s < samples.length; s++) {
                            var ss = samples[s];
                            var sv = new tsm_1.vec3([ss.posx, ss.posy, ss.posz]);
                            var d = sv.subtract(pos).length();
                            if (dist < 0 || d < dist) {
                                index = s;
                                dist = d;
                            }
                        }
                        if (index >= 0) {
                            var si = samples[index];
                            if (currentPos) {
                                // if a current pos was passed in, don't move the camera if the new position is less than 1m away
                                var target = new tsm_1.vec3([si.posx, si.posy, si.posz]);
                                //let startPos = currentPos.copy();
                                var vec = currentPos.subtract(target);
                                var targetDist = vec.length();
                                if (targetDist > 5 || pos === currentPos) {
                                    //console.log("current-target=", startPos, target, vec.length());
                                    return { cam: si, dist: targetDist };
                                }
                                else {
                                    console.log("was already close, not moving");
                                }
                            }
                            else {
                                return { cam: si, dist: -1 };
                            }
                        }
                    }
                }
            }
        }
    }
    return undefined;
}
exports.default = getCameraForPos;
/*
declare global {
    interface Window { test: any}
}

window.test = function(x: number, y: number, z: number){
    return getCameraForPos(new vec3([x, y, z]));
}
/**/ 
//# sourceMappingURL=camera.js.map